import { GenericModalWrapper } from '@/src/components/common/ui/modal'

interface ErrorModalProps {
    isOpen: boolean
    onClose?: () => void
    primaryError: string
    secondaryError?: string
    primaryButtonText?: string
    primaryButtonAction?: () => void
    secondaryButtonText?: string
    secondaryButtonAction?: () => void
}

const ErrorModal: React.FC<ErrorModalProps> = ({
    isOpen,
    primaryError,
    secondaryError,
    primaryButtonText,
    primaryButtonAction,
    secondaryButtonText,
    secondaryButtonAction
}) => {
    return (
        <GenericModalWrapper
            open={isOpen}
            primaryText={primaryError}
            secondaryText={secondaryError}
            primaryCTA={primaryButtonText}
            onPrimaryClick={primaryButtonAction}
            variant="error"
            secondaryCTA={secondaryButtonText}
            onSecondaryClick={secondaryButtonAction}
        />
    )
}

export default ErrorModal
